import { useContext } from 'react';

import { OfferContext } from '@App/contexts/Offer';
import EligibilityLayout from '@src/ui/layouts/EligibilityLayout';
import HtbNextStepsView from '@src/ui/views/offer/HtbNextStepsView';

const HtbNextSteps = () => {
    const { loading } = useContext(OfferContext);

    return (
        <EligibilityLayout loading={loading} showTrustbarV2>
            <HtbNextStepsView />
        </EligibilityLayout>
    );
};

export default HtbNextSteps;
